module.exports = __webpack_public_path__ + "static/logo-ce79d04191ae6a9187572c624ca36130.png";